<template>
  <div class="max-w-7xl px-4 py-8 mx-auto">
    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />
    <PageTitle v-bind:title="title" v-bind:admin="true" />

    <ErrorMessage v-if="errors.load" :error="errors.load" />

    <Loader v-if="loading" />
    <div v-else-if="data.id" class="max-w-full mx-auto my-8 md:max-w-lg">
      <p class="text-sm font-medium text-gray-700">Фото кафедры:</p>
      <img
        v-if="data.image"
        :src="data.image"
        alt=""
        height="300"
        class="h-40 mt-4 rounded-sm"
      />
      <p v-else class="text-sm font-medium text-gray-400">
        Необходимо загрузить изображение:
      </p>
      <form @submit.prevent="submit" class="mt-4">
        <label
          for="file-upload"
          class="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
        >
          <span>Выберите файл для загрузки</span>
          <input
            @change="onAttachmentChange"
            id="file-upload"
            name="file-upload"
            type="file"
            class="sr-only"
          />
        </label>

        <button
          type="submit"
          class="ml-5 bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Сохранить фото
        </button>

        <ErrorMessage v-if="errors.uploadfile" :error="errors.uploadfile" />
      </form>
      <form>
        <input type="hidden" name="id" v-model="data.id" />

        <div class="mt-2">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700"
              >Наименование</label
            >
            <div class="mt-1 relative rounded-md shadow-sm">
              <input
                v-model="data.name"
                type="text"
                name="name"
                id="name"
                class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              />
            </div>
          </div>
          <p
            v-if="errors.validationAdd && errors.validationAdd.name"
            class="mt-2 text-sm text-red-600"
            id="email-error"
          >
            {{ errors.validationAdd.name[0] }}
          </p>
        </div>
        <div>
          <label
            for="description"
            class="block text-sm font-medium text-gray-700"
          >
            Описание
          </label>
          <div class="mt-1">
            <textarea
              v-model="data.description"
              id="description"
              name="description"
              rows="3"
              class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            ></textarea>
          </div>
          <p
            v-if="errors.validationEdit && errors.validationEdit.description"
            class="mt-2 text-sm text-red-600"
          >
            {{ errors.validationEdit.description[0] }}
          </p>
        </div>
      </form>
      <div class="flex justify-end mt-5">
        <button
          type="button"
          class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          @click.prevent="editRecord()"
        >
          Сохранить изменения
        </button>
        <ErrorMessage v-if="errors.edit" :error="errors.edit" />
      </div>

      <!-- <p>Фото кафедры:</p>
      <img
        v-if="data.image"
        :src="data.image"
        alt=""
        height="300"
        class="shadow"
      />
      <p v-else class="alert alert-info">Необходимо загрузить изображение:</p>

      <form @submit.prevent="submit">
        <div class="form-group">
          <div class="custom-file">
            <input
              type="file"
              class="custom-file-input"
              id="customFile"
              @change="onAttachmentChange"
            />
            <label class="custom-file-label" for="customFile"
              >Выберите файл для загрузки</label
            >
          </div>
        </div>
        <div class="form-group">
          <button
            type="submit"
            class="ml-5 bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Сохранить фото
          </button>
        </div>
        <div class="alert alert-danger" v-if="errors.uploadfile">
          {{ errors.uploadfile }}
        </div>
      </form>
      <hr />

      <form>
        <input type="hidden" name="id" v-model="data.id" />
        <div class="form-group">
          <label for="name" class="col-form-label">Наименование:</label>
          <input
            type="text"
            class="form-control"
            id="name"
            name="name"
            v-model="data.name"
          />
          <div
            class="alert alert-danger"
            v-if="errors.validationEdit && errors.validationEdit.name"
          >
            {{ errors.validationEdit.name[0] }}
          </div>
        </div>
        <div class="form-group">
          <label for="description" class="col-form-label">Описание:</label>
          <textarea
            class="form-control"
            name="description"
            id="description"
            cols="30"
            rows="10"
            v-model="data.description"
          ></textarea>
          <div
            class="alert alert-danger"
            v-if="errors.validationEdit && errors.validationEdit.description"
          >
            {{ errors.validationEdit.description[0] }}
          </div>
        </div>
      </form>
      <button
        type="button"
        class="btn btn-primary"
        @click.prevent="editRecord()"
      >
        Сохранить изменения
      </button>
      <div class="alert alert-danger" v-if="errors.edit">
        {{ errors.edit }}
      </div> -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import BreadCrumbs from "@/components/BreadCrumbs";
import PageTitle from "@/components/PageTitle";
import ErrorMessage from "@/components/ErrorMessage";

export default {
  components: {
    Loader,
    BreadCrumbs,
    PageTitle,
    ErrorMessage,
  },
  data() {
    return {
      loading: true,
      data: [],
      errors: { load: "", edit: "", validationEdit: {}, uploadfile: "" },
      bcrumbs: [],
      title: "Редактирование Кафедры",
      attachment: null,
    };
  },

  async mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get(
          "admin/departments/" + this.$route.params.id + "/edit"
        );
        this.data = response.data.department;
        this.bcrumbs = response.data.bcrumbs;
        this.loading = false;
      } catch (e) {
        if (e.response.status == 401) {
          this.errors.load = "Нет доступа.";
        } else {
          this.errors.load = "Ошибка при загрузке данных";
        }
      }
    },

    onAttachmentChange(e) {
      this.attachment = e.target.files[0];
    },

    /*
        async testtest()
        {
            this.errors.uploadfile = ''

            const config = { 'content-type': 'multipart/form-data' }
            const formData = new FormData()
            formData.append('name', this.name)
            formData.append('attachment', this.attachment)





            try {
                // alert(9)
                //let response = await axios.post('admin/departments/'+this.data.id,  Object.assign(this.data, {_method: 'PUT'}))
                 //let response = await axios.post('test/upload4/'+this.data.id, formData, config)


                //let response = await axios.post('admin/departments/'+this.data.id+'/departmentUploadImage', formData, config)  // работает!!!
                let response = await axios.post('admin/departments/'+this.data.id+'/departmentUploadImage', formData, config)
                

                console.log(response)
            }
            catch (e) {
                console.log('ERRR')
            }
        },
*/
    submit() {
      this.errors.uploadfile = "";
      const config = { "content-type": "multipart/form-data" };
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("attachment", this.attachment);

      axios
        .post(
          "admin/departments/" + this.data.id + "/departmentUploadImage",
          formData,
          config
        )
        .then((response) => {
          this.data.image = response.data.image;
          //console.log(response);
        })
        .catch((error) => {
          if (error.response.status == 520) {
            this.errors.uploadfile = error.response.data.error;
          }
          if (error.response.status == 422) {
            this.errors.uploadfile = error.response.data.errors.attachment[0];
          } else {
            this.errors.uploadfile = "Неизвестная ошибка при загрузке файла.";
          }
        });
    },

    //
    // Edit record.
    //
    async editRecord() {
      this.errors.validationEdit = {};
      this.errors.edit = "";
      try {
        //let response = await axios.post('admin/courses/'+this.data.id, {id: this.data.id, name: this.data.name, description: this.data.description, department_id: this.data.department_id, _method: 'PUT'})
        let response = await axios.post(
          "admin/departments/" + this.data.id,
          Object.assign(this.data, { _method: "PUT" })
        );
        if (response.status == 200) {
          this.loadData();
        }
      } catch (e) {
        if (e.response.status == 422) {
          this.errors.validationEdit = e.response.data.errors;
        } else if (e.response.status == 520) {
          this.errors.edit = e.response.data.error;
        } else {
          this.errors.edit = "Неизвестная ошибка при редактировании записи.";
        }
      }
    },
  },
};
</script>